<div class="tooltip"
     [ngStyle]="position"
     (mouseenter)="mouseEnter.emit()"
     (mouseleave)="mouseLeave.emit()"
>
    <div class="tooltip-content" [innerHTML]="content"></div>
    <div class="tooltip-arrow-shadow"></div> <!-- Cień -->
    <div class="tooltip-arrow"></div> <!-- Właściwa strzałka -->
</div>